<header class="c-siteheader">

  <!-- Mobile chrome (native app OR narrow viewport): minimal bar — logo + user name.
       Language / theme / logout live in the "Plus" account screen. -->
  @if (layout.useMobileChrome()) {
  <div class="c-siteheader__mobile">
    <!-- Hidden test-mode gesture (mobile only): kept out of the tab order on purpose -->
    <div class="c-siteheader__mobile-logo" (click)="onLogoTap()" (keyup.enter)="onLogoTap()" tabindex="-1">
      <img [src]="logoUrl()" [alt]="currentLang() === 'fr' ? 'FGTB' : 'ABVV'" class="c-siteheader__mobile-logo-img">
    </div>
    @if (isAuthenticated()) {
      <span class="c-siteheader__mobile-user"><i class="fa fa-user"></i> {{ mobileHeaderName() | titlecase }}</span>
    }
    <a class="c-languagenav__link c-siteheader__mobile-lang" href="javascript:void(0);" (click)="changeLang()">{{ 'LANGUAGE.lang' | translate }}</a>
  </div>
  }

  <!-- Desktop chrome: single top bar — brand zone (aligned with the sidebar) + actions -->
  @if (!layout.useMobileChrome()) {
  <div class="c-siteheader__bar">
    <div class="c-siteheader__brand">
      <div class="c-siteheader__logo" (click)="onLogoTap()" (keyup.enter)="onLogoTap()" tabindex="-1">
        <img class="o-fluidimg" [src]="logoUrl()" [alt]="currentLang() === 'fr' ? 'FGTB' : 'ABVV'">
      </div>
      @if (isAuthenticated() && (!isInternalUser() || member())) {
        <button class="c-sidebar-toggle" type="button" (click)="layout.toggleSidebar()"
                [attr.aria-label]="layout.sidebarCollapsed() ? 'Déplier le menu' : 'Replier le menu'">
          <!-- Inline SVG (not a Font Awesome <i>, which FA's JS would replace and break the
               dynamic rotation). Double chevron pointing left; rotates 180° when collapsed. -->
          <svg class="c-sidebar-toggle__icon" [class.is-collapsed]="layout.sidebarCollapsed()"
               viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor"
               stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
            <path d="M13 6l-6 6 6 6"></path>
            <path d="M19 6l-6 6 6 6"></path>
          </svg>
        </button>
      }
    </div>
    <div class="c-siteheader__actions">
      @if (isInternalUser()) {
        <a class="c-header-search" routerLink="/search" routerLinkActive="is-active">
          <i class="fa-solid fa-magnifying-glass" aria-hidden="true"></i>
          <span>{{ 'MENU.search_member' | translate }}</span>
        </a>
      }
      @if (isAuthenticated()) {
        <p class="c-siteheader__meta-user"><i class="fa fa-user u-margin-right-xs"></i> {{ headerUserLabel() }}</p>
      }
      <a class="c-languagenav__link" href="javascript:void(0);" (click)="changeLang()">{{ 'LANGUAGE.lang' | translate }}</a>
      <button class="c-theme-toggle" (click)="toggleDarkMode()" [attr.aria-label]="themeService.darkMode() ? 'Switch to light mode' : 'Switch to dark mode'">
        <i class="pi" [class.pi-sun]="themeService.darkMode()" [class.pi-moon]="!themeService.darkMode()"></i>
      </button>
      <!-- Desktop logout normally lives at the bottom of the sidebar; this header fallback
           only shows when the sidebar is hidden (internal user with no member selected). -->
      @if (isAuthenticated() && isInternalUser() && !member()) {
        <button class="c-logout-button" (click)="logout()" aria-label="Log out">
          <i class="pi pi-sign-out"></i>
        </button>
      }
    </div>
  </div>
  }

</header>
